import React from "react"
import { CloseIcon } from "../../Icons"
import { getIn } from "formik"
import "./CreatableField.css"

class CreatableField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollWidth: 30,
      input: "",
      focus: false
    }

    this.inputRef = React.createRef()
  }

  handleInputChange = e => {
    const scrollWidth = e.target.scrollWidth
    this.setState({ input: e.target.value, scrollWidth })
  }

  handleInputKeyDown = async e => {
    if (e.keyCode === 13 && e.target.value === "") {
      e.preventDefault()
      return false
    }
    if (e.keyCode === 13 && e.target.value !== "") {
      e.preventDefault()
      const { name, value } = this.props.field
      const { setFieldValue, setFieldTouched } = this.props.form
      const newVal = value || []
      if (!newVal.includes(e.target.value)) {
        newVal.push(e.target.value)
        await setFieldValue(name, newVal)
        setFieldTouched(name)
        this.props.onChange && this.props.onChange()
        this.setState(state => ({
          ...state,
          scrollWidth: 30,
          input: ""
        }))
      }
      return false
    }
  }

  handleRemoveItem = async index => {
    const { name, value } = this.props.field
    const { setFieldValue } = this.props.form
    await setFieldValue(name, value.filter((item, i) => i !== index))
    this.props.onChange && this.props.onChange()
  }

  focusInput = () => {
    this.inputRef.current.focus()
    this.setState({ focus: true })
  }

  handleBlur = async e => {
    this.setState({ focus: false })
    if (e.target.value !== "") {
      const { name, value } = this.props.field
      const { setFieldValue, setFieldTouched } = this.props.form
      const newVal = value || []
      if (!newVal.includes(e.target.value)) {
        newVal.push(e.target.value)
        await setFieldValue(name, newVal)
        setFieldTouched(name)
        this.props.onChange && this.props.onChange()
        this.setState(state => ({
          ...state,
          scrollWidth: 30,
          input: ""
        }))
      } else {
        this.setState({ input: "" })
      }
    }
  }

  render() {
    const { value, name } = this.props.field
    const { errors, touched } = this.props.form
    const { placeholder, placeholderWithContent } = this.props
    let status = "default"
    const error = getIn(errors, name)
    const fieldTouched = getIn(touched, name)
    if (error && fieldTouched) {
      status = "has-error"
    } else if (value && !error) {
      status = "is-fixed"
    }
    return (
      <>
        <div
          className={`CreatableField ${status} ${
            this.state.focus ? "focus" : ""
          }`}
          onClick={this.focusInput}
        >
          <>
            {value &&
              value.length > 0 &&
              value.map((item, i) => (
                <div key={i}>
                  {item}
                  <span onClick={this.handleRemoveItem.bind(this, i)}>
                    <CloseIcon />
                  </span>
                </div>
              ))}
          </>
          <input
            placeholder={
              (value && value.length > 0 && placeholderWithContent) || ""
            }
            ref={this.inputRef}
            value={this.state.input}
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyDown}
            onBlur={this.handleBlur}
            type="text"
            // style={{
            //   width: this.state.scrollWidth + "px"
            // }}
          />

          {value &&
            value.length < 1 && (
              <span className="placeholder">{placeholder}</span>
            )}
        </div>
        {error && fieldTouched && <div className="error-message">{error}</div>}
      </>
    )
  }
}

export default CreatableField
